import React from "react";
import { useParams } from "react-router-dom";
import ApuracaoCat42Conteudo from "./Conteudo";

export default function ApuracaoDetalheCat42() {
  const { id } = useParams();
  return <ApuracaoCat42Conteudo apuracaoId={id} />;
}
